import React, { useState, useRef, useEffect, useContext } from "react";
import Data from "../../translations/en/common.json";
import Slider, { Range, SliderTooltip } from "rc-slider";
import "rc-slider/assets/index.css";
import "./rcSlider.scss";
import { ResumePopupContext } from "../../Context/resumePopupContext";

function RcSlider(props) {
  const [value, setValue] = useState("0");
  const { preview } = useContext(ResumePopupContext);

  const currentRef = useRef();
  const handleChange = (e) => {
    if (!props.skill) {
      Data &&
        Data.proficiency &&
        Data.proficiency.map((language, index) => {
          if (e == language.percent) {
            props.languageHandler(
              "level",
              props.index,
              language.label,
              props.sectionId
            );
          }
        });
    } else {
      props.languageHandler("level", props.index, e, props.sectionId);
    }
  };

  useEffect(() => {
    if (!props.skill) {
      Data &&
        Data.proficiency &&
        Data.proficiency.map((language, index) => {
          if (
            props &&
            props.response &&
            props.response.level == language.label
          ) {
            setValue(language.percent);
          }
        });
    } else {
      setValue(props.value);
    }
  }, [props]);

  return (
    <>
      <Slider
        ref={currentRef}
        trackStyle={{ backgroundColor: props.dots ? "#ecf0f1" : "#27496d" }}
        handleStyle={{
          height: props.dots ? 20 : 9,
          width: props.dots ? 20 : 9,
          marginTop: props.dots ? -10 : -2,
          left: 1,
          backgroundColor: props.dots ? "#4caf5b" : "#ecf0f1",
        }}
        name="level"
        className="rc_slider_div"
        min={1}
        max={10}
        defaultValue={5}
        value={value}
        step={1}
        dots={props.dots}
        onChange={!preview ? handleChange : ""}
        onAfterChange={
          !props.skill ? props.resumeUpdate : props && props.onBlur
        }
      />
    </>
  );
}

export default RcSlider;
